import TextField from './TextField';
import { TextAreaInput } from '../inputs';

class TextAreaField extends TextField {
  fieldComponent = (tempState, state, handle) => {
    const prepHandle = (e) => this.handleInput(e, handle);
    const prepBlur = (e) => this.handleBlurTrim(e, handle);
    return (
      <TextAreaInput
        label={this.label}
        state={tempState?.[this.kWord] ?? state[this.kWord] ?? this.getDefaultState()}
        handle={prepHandle}
        blur={prepBlur}
      />
    );
  }
}

export default TextAreaField;
